
export const filterOptions = [
  { name: 'Reunião da Classe dos Artesãos', label: 'Meditação Aberta', code: 0 },
  { name: 'Convocação Ritualística de templo da loja', label: 'Convocação Ritualística de templo da loja', code: 1 },
  { name: 'Calendário Anual das Atividades Rosacruzes / Atividade do Mês', label: 'Atividade Social', code: 2 },
  { name: 'Atividade Cultural - Social', label: 'Atividade Cultural - Social', code: 3 },
];
export const userType = [
  { value: 'TOM', name: 'TOM', label: 'TOM' },
  { value: 'Rosacruz', name: 'Rosacruz', label: 'Rosacruz' },
  { value: 'OGG', name: 'OGG', label: 'OGG' },
];
